import type { HalfedgeDS } from '../core/HalfedgeDS';
import type { Face } from '../core/Face';

export class FaceMapTxn {
  private dels: Array<[number, number, number]> = [];
  private puts: Array<[number, number, number, Face]> = [];

  constructor(private struct: HalfedgeDS) {}

  deleteTriple(a: number, b: number, c: number) {
    this.dels.push([a, b, c]);
  }
  deleteFace(face: Face) {
    const vs = face.getVertices();
    this.dels.push([vs[0].id, vs[1].id, vs[2].id]);
  }
  putTriple(a: number, b: number, c: number, face: Face) {
    this.puts.push([a, b, c, face]);
  }

  commit() {
    // deletion (independent of orientation)
    for (const [a, b, c] of this.dels) this.struct.verticesToFace.delete(a, b, c);
    // insertion
    for (const [a, b, c, f] of this.puts) this.struct.verticesToFace.set(a, b, c, f);
  }
}
